import styled from "styled-components";
import { colors } from "melodies-source/Theme";
import { ReactComponent as WarningIcon } from "assets/svg/warning.svg";

interface PublishWarningProps {
  message: string;
  className?: string;
}

export const PublishWarning = ({ message, className }: PublishWarningProps) => (
  <Container className={className}>
    <WarningIcon />
    <span>{message}</span>
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid ${colors.yellow40};
  border-radius: 5px;
  background: ${colors.yellow10};
  font-family: var(--max-font-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-color);

  svg {
    flex-shrink: 0;
    color: ${colors.yellow};
    height: 16px;
    width: auto;
  }

  ${({ theme }) => theme.media.mobile} {
    font-size: 12px;
    width: 100%;
    padding: 5px 12px;

    @media (max-width: 400px) {
      font-size: 10px;
    }

    svg {
      height: 14px;
    }
  }
`;
